import { render, staticRenderFns } from "./AdvisorSettlementDetail.vue?vue&type=template&id=4d8b0216&"
import script from "./AdvisorSettlementDetail.vue?vue&type=script&lang=js&"
export * from "./AdvisorSettlementDetail.vue?vue&type=script&lang=js&"
import style0 from "./AdvisorSettlementDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports